// @ts-nocheck

import { BasketStatuses } from '../../../types/basket';
import { basket as BasketUtils } from '../../../utils';

const { generateSystems } = BasketUtils;

/**
 * Return the nextState corresponding to the BASKET_ITEM_BANKER_CHANGE action
 *
 * @param  {Object} state  The actual state.
 * @param  {Object} action The action to reduce.
 * @return {Object}        Return the new state.
 */
const basketItemBankerChange = (state, action) => {
  const { status, items } = state;
  const { oddId, banker } = action.payload;
  if (status !== BasketStatuses.PENDING && status !== BasketStatuses.VALIDATED && status !== BasketStatuses.WAITING) {
    if (items[oddId] !== undefined) {
      const item = items[oddId];
      const { banker: itemBanker } = item;
      if (itemBanker !== banker) {
        const nextItems = {
          ...items,
          [oddId]: {
            ...item,
            banker,
          },
        };

        const nextSystems = generateSystems({ items: nextItems });

        return {
          ...state,
          items: nextItems,
          systems: nextSystems,
        };
      }
    }
  }
  return state;
};

export default basketItemBankerChange;
